import React, { useState } from 'react';
import { arrayMove } from 'react-sortable-hoc';
import Modal from 'react-modal';
import { Grid, Button } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { useSelector, useDispatch } from 'react-redux';

import { getJourneyDetails, showProgress } from '../../redux/actions/DealershipActions';
import service from '../../apis/service';
import { apiEndpoints } from '../../constants/apiEndpoints';
import ReorderComponent from '../common/ReorderComponent';

const ChangeOrderLevel = (props) => {
  const dispatch = useDispatch();
  const [viewChangeOrderPopup, setViewChangeOrderPopup] = useState(props.open);

  const levelIds = useSelector((state) => state.JourneyDetails.journeydetails.levels);
  const journeyId = useSelector((state) => state.getJourneyID);

  const [arr, setArr] = useState({
    items: levelIds || [],
  });

  const changeOrder = async () => {
    dispatch(showProgress(true));
    const levelArr = arr.items?.map((val) => val.id);
    const data = JSON.stringify({
      journeyId,
      sequence: levelArr,
    });
    await service
      .put(apiEndpoints.JOURNEY_LEVEL_SEQUENCE, data)
      .then(() => {
        dispatch(getJourneyDetails('appendLevelIds', arr.items));
        props.close();
        dispatch(showProgress(false));
      })
      .catch((error) => {
        console.log(error);
        dispatch(showProgress(false));
      });
  };
  const closePopup = () => {
    setViewChangeOrderPopup(false);
    props.close();
  };
  const onSortEnd = ({ oldIndex, newIndex }) => {
    setArr(({ items }) => ({
      items: arrayMove(items, oldIndex, newIndex),
    }));
  };

  return (
    <Modal
      isOpen={viewChangeOrderPopup}
      onRequestClose={() => false}
      shouldCloseOnEsc={false}
      style={{
        overlay: { backgroundColor: 'hsla(50, 33%, 25%, 0.35)' },
        content: {
          display: 'flex',
          padding: '20px 16px 28px',
          width: '475px',
          height: '468px',
          background: '#FFFFFF',
          position: 'absolute',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
        },
      }}
    >
      <Grid container direction="column">
        <Grid item>
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="flex-start"
            style={{
              width: '443px',
              height: '82px',
              marginLeft: '16px',
              marginTop: '20px',
            }}
          >
            <Grid item>
              <Grid
                container
                direction="column"
                justifyContent="flex-start"
                alignItems="flex-start"
                style={{ width: '283px', height: '67px' }}
              >
                <Grid item>
                  <div
                    style={{
                      fontFamily: 'Montserrat',
                      fontStyle: 'normal',
                      fontWeight: '600',
                      fontSize: '18px',
                      lineHeight: '22px',
                      display: 'flex',
                      alignItems: 'center',
                      color: 'black',
                    }}
                  >
                    {' '}
                    Change the level order
                  </div>
                </Grid>
                <Grid item>
                  <div
                    style={{
                      fontFamily: 'Montserrat',
                      fontStyle: 'normal',
                      fontWeight: '500',
                      fontSize: '12px',
                      lineHeight: '15px',
                      color: 'rgba(0, 0, 0, 0.4)',
                    }}
                  >
                    Drag and drop to change order
                  </div>
                </Grid>
              </Grid>
            </Grid>
            <Grid item>
              <CloseIcon style={{ cursor: 'pointer' }} onClick={closePopup} />
            </Grid>
          </Grid>
        </Grid>
        <Grid item style={{ height: '67%', overflow: 'auto' }}>
          <ReorderComponent items={arr.items} onSortEnd={onSortEnd} />
        </Grid>
        <Grid item style={{ position: 'absolute', bottom: '3%', marginLeft: '5%' }}>
          <Button
            variant="contained"
            disableElevation
            style={{
              width: '200px',
              height: '42px',
              fontFamily: 'Montserrat',
              fontStyle: 'normal',
              fontWeight: '600',
              fontSize: '14px',
              lineHeight: '17px',
              textAlign: 'center',
            }}
            onClick={closePopup}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={changeOrder}
            style={{
              width: '200px',
              height: '42px',
              marginLeft: '16px',
              fontFamily: 'Montserrat',
              fontStyle: 'normal',
              fontWeight: '600',
              fontSize: '14px',
              lineHeight: '17px',
              textAlign: 'center',
            }}
          >
            <div style={{ color: '#EB5757' }}>Change Order</div>
          </Button>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default ChangeOrderLevel;
